import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNomeTurma = (): TabelaColuna => ({
  Chave: 'nomeTurma',
  Alinhamento: 'center',
  RenderizarCabecalho: () => <div style={{ width: 120 }}>Nome Turma</div>
})
